// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3Oemp","ranges":"BmiRanges_ranges__2COqi"};